{
  "marketing_list": {
    "info": {
      "update_aria_label": "Update list information",
      "list_suffix": "list, ",
      "contacts_total": "contacts in total, last updated at"
    },
    "form": {
      "name_required": "Please name your list",
      "category_required": "Please select a category",
      "list_name_label": "List Name *",
      "list_name_placeholder": "Name of the list",
      "create_header": "Create Marketing List",
      "update_header": "Update Marketing List"
    },
    "header": {
      "archived_label": "archived"
    },
    "actions": {
      "add_contact": "Add Contact",
      "missing_field": "Missing Field",
      "request_contacts": "Request Contacts",
      "add_to_list": "Add to List",
      "log_activity": "Log New Activity",
      "export_selected": "Export Selected",
      "download_export": "Download export"
    },
    "category": {
      "label": "Category",
      "any": "Any"
    },
    "contact_request": {
      "description": "Share this URL to request others to add their contacts to this list."
    },
    "categories": {
      "client_alert": "Client Alert",
      "country_group": "Country Group",
      "event_invite": "Event Invite",
      "general_marketing": "General Marketing",
      "newsletter": "Newsletter",
      "office_lists": "Office Lists",
      "other": "Other",
      "practice_area": "Practice Area",
      "sector_or_industry": "Sector Or Industry",
      "subscribers": "Subscribers",
      "webinar_invite": "Webinar Invite"
    }
  },
  "excluded_contacts": {
    "alert_message": "There are {{count}} contacts in this list with matching exclusion rules.",
    "show_excluded_link": "Show me the excluded contacts."
  },
  "filters": {
    "title": "Filter",
    "contact_status": {
      "label": "Contact Status",
      "all": "All",
      "bounced": "Bounced",
      "unengaged": "Unengaged",
      "marketing_excluded": "Marketing Excluded"
    },
    "consent_status": {
      "label": "Consent Status",
      "legitimate_interest_tooltip": "You may contact the individual without explicit consent due to existing relationship."
    },
    "tags": {
      "label": "Tags",
      "placeholder": "Type or select tags"
    },
    "added_by": {
      "label": "Added by",
      "placeholder": "Type name or email"
    },
    "missing_field": "Missing Field",
    "active_filters_aria": "{{count}} filters are active",
    "apply": "Apply",
    "clear_filters": "Clear Filters",
    "order_by": "Order by"
  },
  "table": {
    "all_contacts_selected": "All {{count}} contacts selected",
    "add_to_list_success": "Request sent. It might take a few minutes to see all the contacts in the target list",
    "columns": {
      "contact": "Contact",
      "company": "Company",
      "consent_status": "Consent Status",
      "tags": "Tags",
      "location": "Location",
      "last_interaction": "Last Interaction",
      "added_date": "Added Date",
      "added_by": "Added By"
    },
    "consent_not_given": "Consent not given",
    "missing_required_fields": "Missing required fields",
    "headers": {
      "list": "List",
      "category": "Category",
      "created_by": "Created by",
      "last_updated": "Last updated"
    }
  },
  "sync": {
    "sync_contacts": "Sync Contacts",
    "sync_with": "Sync with {{type}}",
    "sync_list": "Sync List",
    "audience": "Audience",
    "select_audience": "Select an audience",
    "sync": "Sync",
    "not_available_yet": "Not available yet",
    "connected_to": "Connected to {{type}}",
    "ems_name": "EMS name",
    "last_synced": "Last synced",
    "not_synced_yet": "Not synced yet",
    "disconnect_confirmation": "Are you sure you want to disconnect this list from {{type}}",
    "disconnect_from": "Disconnect from {{type}}",
    "sync_failed": "Sync Failed: ",
    "contacts_need_attention": "{{count}} contacts need your attention before they can be synced.",
    "list_out_of_sync": "List is out of sync.",
    "syncing_in_progress": "Syncing list, this might take a few minutes..."
  },
  "actions": {
    "menu": "Actions",
    "exclusion_rule_list": "Exclusion Rule List",
    "past_exports": "Past Exports"
  },
  "status": {
    "archived": "Archived"
  },
  "ems": {
    "setup_title": "EMS Setup"
  }
}
